import { usePermissions } from 'hooks/usePermissions';
import { useGetOrderCustomData } from 'pages/Orders/hooks/useGetOrderCustomData';
import { ListContextProvider, useList, useRecordContext } from 'react-admin';
import { Card } from 'shared/mui/Card';
import { Datagrid } from 'shared/react-admin/Datagrids';
import { JsonCopyToClipboardField, TextField } from 'shared/react-admin/Fields';
import { Order } from 'types/embedded/order';

export const OrdersShowCustomData = (): JSX.Element => {
  const { hasResourceAccess } = usePermissions();
  const record = useRecordContext<Order>();
  const { data, isFetching } = useGetOrderCustomData(record?.originId);
  const context = useList({ data: data ? [data] : [], isFetching });

  return (
    <Card sx={{ background: 'transparent' }}>
      {hasResourceAccess('order_custom_datas') && (
        <ListContextProvider value={context}>
          <Datagrid
            bulkActionButtons={false}
            rowClick={false}
            sx={{ '& .RaDatagrid-headerCell': { padding: '16px' } }}
          >
            <TextField label="ID" source="id" />
            <JsonCopyToClipboardField collapse={0} label="customData" source="customData" />
          </Datagrid>
        </ListContextProvider>
      )}
    </Card>
  );
};
